const getters = {
  loginFade: state => state.user.loginFade,
  token: state => state.user.token,
  loginStatus: state => state.user.loginStatus,
  loginType: state => state.user.loginType,
  loginPath: state => state.user.loginPath,
  userInfo: state => state.user.userInfo,
  loadedInfo: state => state.user.loadedInfo,
  year: state => state.user.year,
  term: state => state.user.term,
  organization: state => state.user.organization,
  school: state => state.user.school
}
export default getters
